"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sogliano-al-rubicone": {
    "e822db40": [{
      "hkey": "cdc5bdee",
      "slug": "sogliano-al-rubicone",
      "name": "Sogliano al Rubicone",
      "primary": true,
      "skipSearch": false
    }],
    "ginestreto": [{
      "hkey": "cdc5bdee",
      "slug": "sogliano-al-rubicone",
      "name": "Sogliano al Rubicone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a6236bed": [{
      "hkey": "cdc5bdee",
      "slug": "sogliano-al-rubicone",
      "name": "Sogliano al Rubicone",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo-all-uso": [{
      "hkey": "cdc5bdee",
      "slug": "sogliano-al-rubicone",
      "name": "Sogliano al Rubicone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;